"use client";

import styled from "styled-components";

interface DrawerProps {
  $isOpen: boolean;
}

export const Overlay = styled.div<DrawerProps>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? "visible" : "hidden")};
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;

  @media (min-width: 992px) {
    display: none;
  }
`;

export const Drawer = styled.div<DrawerProps>`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 90%;
  max-width: 400px;
  background: var(--backgroundColorCard);
  z-index: 999;
  transform: translateX(${({ $isOpen }) => ($isOpen ? "0" : "-100%")});
  transition: transform 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);

  @media (min-width: 992px) {
    display: none;
  }
`;

export const DrawerHeader = styled.div`
  width: 100%;
  height: 4.5rem;
  border-bottom: 1px solid var(--border);
  background: var(--backgroundColorCard);
  padding: 0 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
`;

export const LogoLink = styled.a`
  width: 100px;
  display: flex;
  align-items: center;
`;

export const CloseButton = styled.button`
  border-radius: 100px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: var(--backgroundColorCard);
  border: 1px solid var(--borderColor);
  transition: all 0.2s ease;

  svg {
    transform: rotate(180deg);
    transition: transform 0.3s ease;

    path {
      transition: 0.3s;
      stroke: var(--primarySystem100);
      fill: transparent;
    }
  }

  &:hover {
    background: var(--primarySystem100);
    border-color: var(--primarySystem100);

    svg {
      path {
        stroke: #fff;
      }
    }
  }
`;

export const DrawerUserSection = styled.div`
  width: 100%;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border);
  background: var(--backgroundColorCard);
  flex-shrink: 0;
`;

export const DrawerContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1.25rem 0.75rem;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar-track {
    background: var(--transparent);
  }

  &::-webkit-scrollbar {
    width: 3px;
    background: var(--transparent);
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: var(--border);
  }
`;

export const DrawerFooter = styled.div`
  width: 100%;
  padding: 1rem 1.25rem;
  border-top: 1px solid var(--border);
  background: var(--backgroundColorCard);
  flex-shrink: 0;
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  width: 100%;
`;

export const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  background: transparent;
  border: 1px solid var(--borderColor);
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--colorTitle);
  font-family: "Roboto Regular";
  font-size: 14px;

  svg {
    color: var(--colorTitle);
    transition: color 0.2s ease;
  }

  &:hover {
    background: var(--red);
    border-color: var(--red);
    color: #fff;

    svg {
      color: #fff;
    }
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const LogoutText = styled.span`
  font-family: "Roboto Regular";
  font-size: 14px;
  color: inherit;
`;
